export default __webpack_public_path__ + "static/kontakt-bg-main-14545d73e68a7d46b1b5cf2d38b29cfa.jpg";